import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useNavigate } from 'react-router-dom'

function HomePageCoinDetails() {
  const [HomePageCoinApi, setHomePageCoinApi] = useState([]);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(100);
  const [currentPage2, setcurrentPage2] = useState(1);
  const [listPerpage2, setlistPerpage2] = useState(100);
  let navigate= useNavigate();

  const HomePageCoin_API = async () => {
    try {
      let res = await API.get(`/GetAllHomePageToken?id=0`);
      console.log("res GetAllHomePageToken", res.data.data);
      res=res.data.data;
      setHomePageCoinApi([]);
      let arrayData = [];
      res.forEach((item, index) => {
        arrayData.push({
          sr: index + 1,
          id: `${item?.id}`,
          coin_url: `${item?.coin_url} `,
          rate_value: `${item?.rate_value} `,
          coin_name: `${item?.coin_name}`,
          name: `${item?.name}`,
          edate: `${item?.edate}`,
          edit : `${item?.id}`,
        });

        setHomePageCoinApi(arrayData);
      });
   
      console.log("arrayData",arrayData);
      
    } catch (e) {
      console.log("Error While calling Myteam API", e);
    }
  };

  useEffect(() => {
    HomePageCoin_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const indexOfLastPost2 = currentPage2 * listPerpage2;
  const indexOfFirstPage2 = indexOfLastPost2 - listPerpage2;
  const currentPost = HomePageCoinApi.slice(indexOfFirstPage, indexOfLastPost);
  const currentPostleft = HomePageCoinApi.slice(
    indexOfFirstPage2,
    indexOfLastPost2
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No", accessor: "sr" },
      { Header: "Coin Name", accessor: "coin_name" },
      { Header: "Coin URL", accessor: "coin_url" },
      { Header: "Desc", accessor: "name" },
      { Header: "Coin Rate", accessor: "rate_value" },
      { Header: "Date", accessor: "edate" },
      //  { Header: 'Action', accessor: 'action' },
       {
        Header: "Edit",
        accessor: "edit",
        Cell: ({ cell }) => (
          <button
            class="btn btn-primary"
            id={cell.row.values.edit}
            onClick={() => {
              navigate(`/Update_HomePageCoin?id=${cell.row.values.edit}`);
            }}
          >
            Edit
          </button>
        ),
      },
    ],
  });

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="container">
            {/* <!-- Inline Form --> */}
            <div class="row">
              <div class="col-md-12">
                <div class="panel panel-primary">
                  <div class="panel-heading">
                    <h4 class="panel-title"> Home Page Coin Details</h4>
                  </div>
                  <div
                    class="panel-body table-rep-plugin"
                    style={{ padding: "8px", overflowY: "scroll" }}
                  >
                    <div class="col-md-12">
                      <div class="row">
                        <form
                          action="#"
                          method="post"
                          class="ng-pristine ng-valid"
                        >
                          {/* <div class="col-sm-2">
                            <input
                              class="form-control in-ip-1"
                              id="uid"
                              onChange={(e) => setSearch(e.target.value)}
                              name="uid"
                              placeholder="Enter User Id"
                              type="text"
                            />
                          </div>
                          <div class="col-sm-2">
                            <input
                              type="button"
                              id="btnsearch"
                              onClick={() => referral_API()}
                              class="btn btn-sm btn-primary"
                              value="Search"
                            />
                          </div> */}
                        </form>
                      </div>

                      <div class="row">
                        <div class="panel-heading">
                          <h4 class="panel-title"></h4>
                        </div>
                        <div
                          class="table-responsive"
                          data-pattern="priority-columns"
                          style={{ maxHeight: "500px", overflow: "scroll" }}
                        >
                          <Table
                            data={currentPostleft}
                            columns={my_team.cols}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePageCoinDetails;
